require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-shwetajalanofadventinternational.json") })
        }
      }, "path---insights-shwetajalanofadventinternational");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-shwetajalanofadventinternational!./.cache/json/insights-shwetajalanofadventinternational.json
// module id = 1126
// module chunks = 231608221292675